import type { AnalyticsShoppingFinishedCallbackProps } from '../components/SkuViewed/Context';
import type { PageActionFireFn } from '../hooks/usePageAction';
import type { SkuViewedPayload } from '../Shibuya';
import { FinishType } from '../types';

interface NonMonetizingHandleOnClickProps {
  fireNonMonetizingPageAction?: PageActionFireFn;
}

interface WithOptionalMonetizingOnClickProps extends NonMonetizingHandleOnClickProps {
  type?: string;
}

interface WithMonetizingHandleOnClickProps extends WithOptionalMonetizingOnClickProps {
  fireShoppingFinishedEvent: (props: AnalyticsShoppingFinishedCallbackProps) => void;
  destinationUrl: string;
  overrideShoppingFinishedId: string;
  monetizable: Required<SkuViewedPayload>['monetizable'];
}

interface WithOutMonetizingHandleOnClickProps extends WithOptionalMonetizingOnClickProps {
  fireShoppingFinishedEvent?: (props: AnalyticsShoppingFinishedCallbackProps) => void;
  destinationUrl?: string;
  overrideShoppingFinishedId?: string;
  monetizable?: Required<SkuViewedPayload>['monetizable'];
}

function isMonetizingHandler(
  props: WithMonetizingHandleOnClickProps | WithOutMonetizingHandleOnClickProps,
): props is WithMonetizingHandleOnClickProps {
  return !!props.fireShoppingFinishedEvent;
}

export function createHandleOnClick(
  props: WithMonetizingHandleOnClickProps | WithOutMonetizingHandleOnClickProps,
) {
  return () => {
    const {
      fireShoppingFinishedEvent,
      fireNonMonetizingPageAction,
      type = 'APPLY_NOW_BUTTON',
    } = props;

    if (fireNonMonetizingPageAction) {
      fireNonMonetizingPageAction();
    }
    if (fireShoppingFinishedEvent && isMonetizingHandler(props)) {
      const { destinationUrl, overrideShoppingFinishedId, monetizable } = props;
      return fireShoppingFinishedEvent({
        destinationUrl,
        overrideShoppingFinishedId,
        ctaType: type,
        finishType: FinishType.ExternalApplication,
        interstitialClientBotSuspected: false,
        monetizable,
      });
    }
  };
}

interface TransformApplyLinkProps {
  applyLink: string;
  shoppingFinishedId: string;
}
export const transformApplyLink = ({ applyLink, shoppingFinishedId }: TransformApplyLinkProps) => {
  const url = new URL(applyLink);
  if (!url.searchParams.has('shopping_finish_id')) {
    url.searchParams.append('shopping_finish_id', shoppingFinishedId);
  } else {
    url.searchParams.set('shopping_finish_id', shoppingFinishedId);
  }
  return url.toString();
};
